import { Link } from "react-router-dom";

interface LogoProps {
  variant?: "dark" | "light";
}

export default function Logo({ variant = "dark" }: LogoProps) {
  const textColor = variant === "light" ? "text-background-50" : "text-foreground-950";
  const subColor = variant === "light" ? "text-background-200" : "text-foreground-500";
  return (
    <Link to="/" className="flex items-center gap-2.5 cursor-pointer group">
      <span className="w-10 h-10 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center text-xl transition-transform duration-300 group-hover:scale-105">
        <i className="ri-film-line" />
      </span>
      <span className="flex flex-col leading-none">
        <h1 className={`font-heading text-xl font-bold tracking-wide ${textColor}`}>
          天天影院
        </h1>
        <span className={`text-[10px] tracking-[0.25em] uppercase ${subColor}`}>
          TianTian Cinema
        </span>
      </span>
    </Link>
  );
}